import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '~/components/section-title';
import { StepScroll } from '~/components/step-scroll';
import { UserCard } from '~/components/user-card';
import { ModuleType } from '~/utils/module-type';
import { ViewTracker } from '~/components/view-tracker';
import { User } from 'shared/models/legacy';
import { $CurrentAvailableDiscoverDataOrNull } from '@discover/shared/atom';

export const DiscoverUserSection: FC = () => {
  const { t } = useTranslation();
  const { keyword } = useParams<{ keyword: string }>();

  const data = useAtomValue($CurrentAvailableDiscoverDataOrNull);
  const users = data ? data.user.items : [];

  const sendTrackingEvent = useCallback(() => {
    window.Tea('wap_module_show', {
      current_page_module: ModuleType.related_user,
      page_id: keyword,
    });
  }, []);

  if (!users.length) {
    return null;
  }

  return (
    <ViewTracker key="discover-user" onView={sendTrackingEvent}>
      <section key="kep-user-section" id="discover-user">
        <SectionTitle title={t('wap_seo_recommend_user')} />
        <StepScroll>
          {users.map((user: User) => (
            <UserCard user={user} key={user.userId} />
          ))}
        </StepScroll>
      </section>
    </ViewTracker>
  );
};
